import { DATA_AI_POWERED_DOC_INLCM_1 } from "./AiPoweredDoc/307DataAiPoweredDocINLCM1";
import { DATA_AI_POWERED_DOC_INLCM_3 } from "./AiPoweredDoc/309DataAiPoweredDocINLCM3";
import { DATA_AI_POWERED_DOC_INLCM_END } from "./AiPoweredDoc/3099DataAiPoweredDocINLCMEnd";
import { DATA_DIGITAL_TWIN_INLCM_1 } from "./DigitalTwin/310DataDigitalTwinINLCM1";
import { DATA_DIGITAL_TWIN_INLCM_2 } from "./DigitalTwin/311DataDigitalTwinINLCM2";
import { DATA_DIGITAL_TWIN_INLCM_3 } from "./DigitalTwin/312DataDigitalTwinINLCM3";
import { DATA_DIGITAL_TWIN_INLCM_4 } from "./DigitalTwin/313DataDigitalTwinINLCM4";
import { DATA_ACCESS_NETWORK_ROLLOUT_INLCM_2 } from "./AccessNetworkRollout/316DataAccessNetworkRolloutINLCM2";
import { DATA_ACCESS_NETWORK_ROLLOUT_INLCM_3 } from "./AccessNetworkRollout/317DataAccessNetworkRolloutINLCM3";
import { DATA_ACCESS_NETWORK_ROLLOUT_INLCM_4 } from "./AccessNetworkRollout/318DataAccessNetworkRolloutINLCM4";
import { DATA_ACCESS_NETWORK_ROLLOUT_INLCM_5 } from "./AccessNetworkRollout/319DataAccessNetworkRolloutINLCM5";
import { DATA_ACCESS_NETWORK_ROLLOUT_INLCM_END } from "./AccessNetworkRollout/3211DataAccessNetworkRolloutINLCMEnd";
import { DATA_TRANSPORT_NETWORK_INLCM_1 } from "./TransportNetwork/322DataTransportNetworkINLCM1";
import { DATA_TRANSPORT_NETWORK_INLCM_2 } from "./TransportNetwork/323DataTransportNetworkINLCM2";
import { DATA_TRANSPORT_NETWORK_INLCM_END } from "./TransportNetwork/345DataTransportNetworkINLCMEnd";
import { DATA_INTRO_INLCM } from "./Introduction/301DataIntroINLCM";
import { DATA_BENEFITS_INLCM_1 } from "./Introduction/302DataBenefitsINLCM1";
import { DATA_BENEFITS_INLCM_2 } from "./Introduction/303DataBenefitsINLCM2";
import { DATA_BENEFITS_INLCM_3 } from "./Introduction/304DataBenefitsINLCM3";
import { DATA_BENEFITS_INLCM_4 } from "./Introduction/305DataBenefitsINLCM4";
import { DATA_BENEFITS_INLCM_5 } from "./Introduction/306DataBenefitsINLCM5";
import { DATA_DIGITAL_TWIN_INLCM_END } from "./DigitalTwin/3144DataDigitalTwinINLCMEnd";
import { DATA_ACCESS_NETWORK_ROLLOUT_INLCM_1 } from "./AccessNetworkRollout/315DataAccessNetworkRolloutINLCM1";
import { DATA_ACCESS_NETWORK_ROLLOUT_INLCM_6 } from "./AccessNetworkRollout/320DataAccessNetworkRolloutINLCM6";
import { DATA_TRANSPORT_NETWORK_INLCM_9 } from "./TransportNetwork/330DataTransportNetworkINLCM9";
import { DATA_TRANSPORT_NETWORK_INLCM_12 } from "./TransportNetwork/333DataTransportNetworkINLCM12";
import { DATA_TRANSPORT_NETWORK_INLCM_13 } from "./TransportNetwork/334DataTransportNetworkINLCM13";
import { DATA_TRANSPORT_NETWORK_INLCM_14 } from "./TransportNetwork/335DataTransportNetworkINLCM14";
import { DATA_TRANSPORT_NETWORK_INLCM_15 } from "./TransportNetwork/336DataTransportNetworkINLCM15";
import { DATA_DIGITAL_TWIN_INLCM_5 } from "./DigitalTwin/314DataDigitalTwinINLCM55";
import { DATA_AI_POWERED_DOC_INLCM_2 } from "./AiPoweredDoc/308DataAiPoweredDocINLCM2";
import { DATA_ACCESS_NETWORK_ROLLOUT_INLCM_1_1 } from "./AccessNetworkRollout/315DataAccessNetworkRolloutINLCM1_1";
import { DATA_ACCESS_NETWORK_ROLLOUT_INLCM_7 } from "./AccessNetworkRollout/321DataAccessNetworkRolloutINLCM7";

export const INLCM_WORKFLOW = [
  {
    page: "ENG_301",
    type: "intro-template" as TemplateType,
    data: DATA_INTRO_INLCM,
  },
  {
    page: "ENG_302",
    type: "benefits-template" as TemplateType,
    data: DATA_BENEFITS_INLCM_1,
  },
  {
    page: "ENG_303",
    type: "benefits-template" as TemplateType,
    data: DATA_BENEFITS_INLCM_2,
  },
  {
    page: "ENG_304",
    type: "benefits-template" as TemplateType,
    data: DATA_BENEFITS_INLCM_3,
  },
  {
    page: "ENG_305",
    type: "benefits-template" as TemplateType,
    data: DATA_BENEFITS_INLCM_4,
  },
  {
    page: "ENG_306",
    type: "benefits-template" as TemplateType,
    data: DATA_BENEFITS_INLCM_5,
  },
  {
    page: "ENG_307",
    type: "journey-two-template" as TemplateType,
    data: DATA_AI_POWERED_DOC_INLCM_1,
  },
  {
    page: "ENG_308",
    type: "journey-two-template" as TemplateType,
    data: DATA_AI_POWERED_DOC_INLCM_2,
  },
  {
    page: "ENG_309",
    type: "journey-two-template" as TemplateType,
    data: DATA_AI_POWERED_DOC_INLCM_3,
  },
  {
    page: "ENG_3099",
    type: "end-template" as TemplateType,
    data: DATA_AI_POWERED_DOC_INLCM_END,
  },
  {
    page: "ENG_310",
    type: "journey-two-template" as TemplateType,
    data: DATA_DIGITAL_TWIN_INLCM_1,
  },
  {
    page: "ENG_311",
    type: "journey-two-template" as TemplateType,
    data: DATA_DIGITAL_TWIN_INLCM_2,
  },
  {
    page: "ENG_312",
    type: "journey-two-template" as TemplateType,
    data: DATA_DIGITAL_TWIN_INLCM_3,
  },
  {
    page: "ENG_313",
    type: "journey-two-template" as TemplateType,
    data: DATA_DIGITAL_TWIN_INLCM_4,
  },
  {
    page: "ENG_314",
    type: "journey-two-template" as TemplateType,
    data: DATA_DIGITAL_TWIN_INLCM_5,
  },
  {
    page: "ENG_3144",
    type: "end-template" as TemplateType,
    data: DATA_DIGITAL_TWIN_INLCM_END,
  },
  {
    page: "ENG_315",
    type: "journey-two-template" as TemplateType,
    data: DATA_ACCESS_NETWORK_ROLLOUT_INLCM_1_1,
  },
  {
    page: "ENG_3155",
    type: "journey-two-template" as TemplateType,
    data: DATA_ACCESS_NETWORK_ROLLOUT_INLCM_1,
  },
  {
    page: "ENG_316",
    type: "journey-two-template" as TemplateType,
    data: DATA_ACCESS_NETWORK_ROLLOUT_INLCM_2,
  },
  {
    page: "ENG_317",
    type: "journey-two-template" as TemplateType,
    data: DATA_ACCESS_NETWORK_ROLLOUT_INLCM_3,
  },
  {
    page: "ENG_318",
    type: "journey-two-template" as TemplateType,
    data: DATA_ACCESS_NETWORK_ROLLOUT_INLCM_4,
  },
  {
    page: "ENG_319",
    type: "journey-two-template" as TemplateType,
    data: DATA_ACCESS_NETWORK_ROLLOUT_INLCM_5,
  },
  {
    page: "ENG_320",
    type: "journey-two-template" as TemplateType,
    data: DATA_ACCESS_NETWORK_ROLLOUT_INLCM_6,
  },
  {
    page: "ENG_321",
    type: "journey-two-template" as TemplateType,
    data: DATA_ACCESS_NETWORK_ROLLOUT_INLCM_7,
  },
  {
    page: "ENG_3211",
    type: "end-template" as TemplateType,
    data: DATA_ACCESS_NETWORK_ROLLOUT_INLCM_END,
  },
  {
    page: "ENG_322",
    type: "journey-two-template" as TemplateType,
    data: DATA_TRANSPORT_NETWORK_INLCM_1,
  },
  {
    page: "ENG_323",
    type: "journey-two-template" as TemplateType,
    data: DATA_TRANSPORT_NETWORK_INLCM_2,
  },
  {
    page: "ENG_330",
    type: "journey-two-template" as TemplateType,
    data: DATA_TRANSPORT_NETWORK_INLCM_9,
  },
  {
    page: "ENG_333",
    type: "journey-two-template" as TemplateType,
    data: DATA_TRANSPORT_NETWORK_INLCM_12,
  },
  {
    page: "ENG_334",
    type: "journey-two-template" as TemplateType,
    data: DATA_TRANSPORT_NETWORK_INLCM_13,
  },
  {
    page: "ENG_335",
    type: "journey-two-template" as TemplateType,
    data: DATA_TRANSPORT_NETWORK_INLCM_14,
  },
  {
    page: "ENG_336",
    type: "journey-two-template" as TemplateType,
    data: DATA_TRANSPORT_NETWORK_INLCM_15,
  },
  {
    page: "ENG_345",
    type: "end-template" as TemplateType,
    data: DATA_TRANSPORT_NETWORK_INLCM_END,
  },
];
